

import React from 'react';
import './error.scss';

function ErrorPage(props) {
   return (
      <div className='error-page'>
         <div className='error-edd'>EDDESS</div>
         <div className='error-inner text-center'>
            <h1>Error</h1>
            <h2>status code <strong>404</strong></h2>
         </div>
         <div className='e-shadow esd-1'></div>
         <div className='e-shadow esd-2'></div>
         <div className='e-shadow esd-3'></div>
         <div className='e-shadow esd-4'></div>
         <div className='e-shadow esd-5'></div>
         <div className='e-shadow esd-6'></div>
         <div className='e-shadow esd-7'></div>
         <div className='e-shadow esd-8'></div>
         <div className='e-shadow esd-9'></div>
         <div className='e-shadow esd-10'></div>
      </div>
   );
}

export default ErrorPage;